import React from "react";
import {getUnderOver} from "../../../../constants/rollet";
const UnderOverMobile = ({ underOverItems = [] }) => {
    const rows = [];

    for (let i = 0; i < underOverItems.length; i++) {
        const rowNum = underOverItems[i] || [];
        const cols = [];

        for (let j = 0; j < rowNum.length; j++) {
            const col = rowNum[j];
            const value = col?.length > 0 ? col.split("_")[1] : "";
            const type = value ? String(getUnderOver(value)).toLowerCase() : "";

            cols.push(
                <td key={`${i}-${j}`} className="rhm-table__cell">
                    {col?.length > 0 ? (
                        <div className="rhm-cell">
                            <span className={`rhm-circle rhm-circle--${type}`}>{value}</span>
                        </div>
                    ) : (
                        <div className="rhm-cell rhm-cell--empty" />
                    )}
                </td>
            );
        }

        rows.push(<tr key={i}>{cols}</tr>);
    }

    return rows;
};

export default UnderOverMobile;